<div *ngIf="((!(hasViewMoneyAccess$ | async) && (authorizedFinished$ | async)) || (authorizedFailed$ | async))" id="create-request-container">
  <mm-view-move-money-page></mm-view-move-money-page>
</div>
<div *ngIf="(hasViewMoneyAccess$ | async)" id="create-request-container">
<div *ngIf="accountInContext || masterAccountInContext || palAccountInContext else legacyRedirect;">
  <ng-container *ngIf="(shouldDisplayAgreement$ | async); then firstTimeUserContent; else content;"></ng-container>
  <ng-template #content>
    <ng-container *ngIf="showMasterStatusView; then masterStatusViewContent; else accountViewContent;"></ng-container>
    <ng-template #masterStatusViewContent>
      <div id="master-status-content" data-testid="master-status-content">
        <mm-master-status-view></mm-master-status-view>
        <mm-view-page id="master-view-page" *ngIf="(createRequestStep$ | async) === 'view-msv'"></mm-view-page>
      </div>
    </ng-template>
    <ng-template #accountViewContent>
      <div id="create-request-content">
        <ng-container *ngIf="hasBadRequestServiceError || hasAtpTimeoutError">
          <mm-banners *ngFor="let error of serviceErrorList" [bannerText]="[error]" [type]="'error'"
            id="reviewPageAckList_badRequestServiceError" data-testid="reviewPageAckList_badRequestServiceError"></mm-banners>
        </ng-container>
        <mm-banners *ngIf="hasServiceError" [serviceError]="(transactionFormServiceError$ | async)!" [type]="'error'"
          id="reviewPageAckList_serviceError" data-testid="reviewPageAckList_serviceError"></mm-banners>
        <mm-account-info></mm-account-info>
        <mm-confirmation-popup [showModal]="showOverdraftRulesPopup$"></mm-confirmation-popup>
        <mm-cancel-modal-v2></mm-cancel-modal-v2>
        <mm-twe-modal [showModal]="showTweModal$" [upcomingTransactions$]="tweUpcomingTransactions$"
          [sloas$]="tweStandingAuth$" [recurringTransactions$]="tweRecurringTransactions$"
          [taxWithholdings$]="taxWithholdings$" [tweTableState$]="tweTableState$"
          (deleteNewAchProfileFromReview)="deleteNewAchProfileFromReview($event)"></mm-twe-modal>
        <mm-save-as-template-modal [showModal]="saveAsTemplateClicked$"
          (saveTemplate)="saveTemplate($event)"></mm-save-as-template-modal>
        <div *ngIf="(createRequestStep$ | async) === 'input'">
          <mm-input-page (showTweModal)="showTweModal($event)" (showTemplateModal)="saveAsTemplateClicked($event)"
            (showOverdraftRulesPopup)="showOverdraftRulesPopup($event)"
            [palAccountInContext]="palAccountInContext"></mm-input-page>
        </div>
        <div *ngIf="(createRequestStep$ | async) === 'view'">
          <mm-view-page></mm-view-page>
        </div>
        <div *ngIf="(createRequestStep$ | async) === 'review'">
          <mm-review-page (deleteNewAchProfileFromReview)="deleteNewAchProfileFromReview($event)"></mm-review-page>
        </div>
        <div *ngIf="(createRequestStep$ | async) === 'confirmation'">
          <mm-confirmation-page [requestSuccessful]="hideErrorBannerAfterSuccessful()"
            (saveAsTemplateClicked)="saveAsTemplateClicked($event)"></mm-confirmation-page>
        </div>
      </div>
    </ng-template>

  </ng-template>
  <ng-template #firstTimeUserContent>
    <div id="first-time-user-content">
      <div id="agreement-text" data-testid="firstTimeUserAgreementText" [innerHtml]="firstTimeUserAgreementText"> </div>
      <sdps-divider class="sdps-m-vertical_medium" variation="secondary"></sdps-divider>

      <p id="first-time-agreement-checkbox-alert">
        <input type="checkbox" id="checkBox-First-Time-User-Accept" data-testid="first-time-agreement-checkbox-alert"
          (change)="checkboxDisclaimerClickedShowsAgreementAcceptButton($event.target)">
        <label for="checkBox-First-Time-User-Accept" class="col-md-12 text-right">
          By checking this checkbox, I agree to the preceding Move Money terms and Conditions.</label>
      </p>

      <sdps-divider class="sdps-m-vertical_medium" variation="secondary"></sdps-divider>

      <sdps-button id="accept-First-Time-Agreement-Button" data-testid="accept-First-Time-Agreement-Button"
        variation="primary" type="button" *ngIf="showAgreementAcceptButton" (click)="onFirstTimeAgreementSubmitClick()"
        size="small" class="first-time-submit-buttons-a-1-primary-smal">Submit</sdps-button>
    </div>
  </ng-template>
</div>
</div>
<ng-template #legacyRedirect>
  <mm-legacy-redirect-landing-page></mm-legacy-redirect-landing-page>
</ng-template>
<ng-template #viewMoveMoneyError>
  <mm-view-move-money-page></mm-view-move-money-page>
</ng-template>